// DOMINO tile — the number is carried by the pips, split across two halves.
const GRID = {
  0: [], 1: [4], 2: [0, 8], 3: [0, 4, 8], 4: [0, 2, 6, 8],
  5: [0, 2, 4, 6, 8], 6: [0, 3, 6, 2, 5, 8],
};

const Half = ({ count, dot, size }) => {
  const active = new Set(GRID[count] || []);
  const pad = size * 0.16;
  const d = size * 0.14;
  return (
    <div
      style={{
        width: size, height: size, position: "relative",
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr", gridTemplateRows: "1fr 1fr 1fr",
        padding: pad,
      }}
    >
      {Array.from({ length: 9 }).map((_, i) => (
        <div key={i} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          {active.has(i) && (
            <span style={{ width: d, height: d, borderRadius: "50%", background: dot, display: "block" }} />
          )}
        </div>
      ))}
    </div>
  );
};

export const DominoTile = ({ pips = [0, 0], variant = "noire", size = 96, alt }) => {
  const [l, r] = pips;
  const noire = variant === "noire";
  const face = noire ? "#141414" : "#faf8f2";
  const dot = noire ? "#efece3" : "#141414";
  const edge = noire ? "#141414" : "#1a1a1a";
  return (
    <div
      role="img"
      aria-label={alt}
      style={{
        width: size, height: size * 2, background: face,
        border: `1px solid ${edge}`, borderRadius: size * 0.12,
        display: "flex", flexDirection: "column",
        boxShadow: noire ? "0 30px 60px -40px rgba(0,0,0,.7)" : "0 30px 60px -40px rgba(0,0,0,.25)",
      }}
    >
      <Half count={l} dot={dot} size={size} />
      <div style={{ height: 1, background: edge, opacity: 0.5, margin: `0 ${size * 0.12}px` }} />
      <Half count={r} dot={dot} size={size} />
    </div>
  );
};
